import { SEVERITY, type LoggerAdapter, type LogRecord, type Severity } from '../logger-types';

type ConsoleMethod = (...args: unknown[]) => void;

const CONSOLE_METHOD_BY_SEVERITY: Record<Severity, () => ConsoleMethod> = {
  [SEVERITY.ERROR]: () => console.error,
  [SEVERITY.WARN]: () => console.warn,
  [SEVERITY.INFO]: () => console.info,
  [SEVERITY.DEBUG]: () => console.debug,
};

export class ConsoleLoggerAdapter implements LoggerAdapter {
  emit(record: LogRecord): void {
    const method = CONSOLE_METHOD_BY_SEVERITY[record.severity]();
    const prefix = `[${record.severity.toUpperCase()}][${record.scope}]`;

    if (Object.keys(record.attributes).length === 0) {
      method(prefix, record.body);
      return;
    }

    method(prefix, record.body, record.attributes);
  }
}
